import api from "./api";
import wx from "weixin-js-sdk";

let currentUrl,currentWechatSDKData,currentPayUrl,currentWechatPaySDKData = {};
export default {
    wechatReady(callback){
        let u = window.navigator.userAgent, app = window.navigator.appVersion;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

        if((currentWechatSDKData && isiOS) || currentUrl === window.location.href){
            wx.config(currentWechatSDKData);
            wx.ready(() => {
                callback(currentWechatSDKData);
            });
        }else{
            currentUrl = window.location.href;
            api.request('/common/get_wechat_sdk_config', {
                url : currentUrl,
            }).then(res => {
                wx.config(res.data);
                currentWechatSDKData = res.data;
                wx.ready(() => {
                    callback(res.data);
                });
            }).catch(res => {
                alert(JSON.stringify(res));
            });
        }
    },
    wechatPayReady(app_id, callback){
        let u = window.navigator.userAgent, app = window.navigator.appVersion;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let self = this;

        if(currentWechatPaySDKData[app_id] && isiOS){
            wx.config(currentWechatPaySDKData[app_id]);
            wx.ready(() => {
                callback(currentWechatPaySDKData[app_id]);
            });
        }else{
            api.request('/common/get_wechat_pay_sdk_config', {
                app_id: app_id,
                url : window.location.href,
            }).then(res => {
                wx.config(res.data);
                currentWechatPaySDKData[app_id] = res.data;
                wx.ready(() => {
                    callback(res.data);
                });
            }).catch(res => {
                self.wechatReady(callback);
            });
        }
    },
    convertCouponData(coupon){
        let templateInfo = coupon['coupon']['template'];
        let valueDesc,unitDesc, condition;
        // 满减券或者立减券
        if(templateInfo['type'] === 'full_reduction' || templateInfo['type'] === 'reduction'){
            valueDesc = templateInfo['rule']['reduce'];
            unitDesc = '元';
            if(templateInfo['type'] === 'full_reduction'){
                condition = '满' + templateInfo['rule']['full_condition'] + '元可用';
            }else if(templateInfo['type'] === 'reduction'){
                condition = '无门槛';
            }
        }
        if(templateInfo['type'] === 'discount'){
            valueDesc = templateInfo['rule']['discount'];
            unitDesc = '折';
            condition = '满' + templateInfo['rule']['full_condition'] + '元可用' + (templateInfo['rule']['max_deduction'] ? ('\n最高抵扣' + templateInfo['rule']['max_deduction'] + '元') : '');
        }
        let start_time = coupon.start_time.replace(/-/g, '/');
        let expire_time = coupon.expire_time.replace(/-/g, '/');
        return {
            info : coupon,
            available: 1,
            condition: condition,
            reason: coupon['disabled'] ? coupon['disabled_info']['msg'] : '',
            value: coupon['discount_amount'] ? coupon['discount_amount'] * 100 : 0,
            name: templateInfo.name,
            startAt: (new Date(start_time)).getTime() / 1000,
            endAt: (new Date(expire_time)).getTime() / 1000,
            valueDesc: valueDesc,
            unitDesc: unitDesc,
        };
    },
    accAdd(arg1, arg2) {
        var r1, r2, m, c;
        try {
            r1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
            r2 = 0;
        }
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        if (c > 0) {
            var cm = Math.pow(10, c);
            if (r1 > r2) {
                arg1 = Number(arg1.toString().replace(".", ""));
                arg2 = Number(arg2.toString().replace(".", "")) * cm;
            } else {
                arg1 = Number(arg1.toString().replace(".", "")) * cm;
                arg2 = Number(arg2.toString().replace(".", ""));
            }
        } else {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", ""));
        }
        return (arg1 + arg2) / m;
    },
};



// WEBPACK FOOTER //
// ./src/assets/js/common.js